import { render } from "./UserWalletHistory.vue?vue&type=template&id=53cf2576"
import script from "./UserWalletHistory.vue?vue&type=script&lang=js"
export * from "./UserWalletHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__